import { render } from "./EditColumnModal.vue?vue&type=template&id=053097e2&scoped=true"
import script from "./EditColumnModal.vue?vue&type=script&lang=js"
export * from "./EditColumnModal.vue?vue&type=script&lang=js"

import "./EditColumnModal.vue?vue&type=style&index=0&id=053097e2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-053097e2"]])

export default __exports__